import type React from "react";
import {
  getCellWidth,
  getFixedColumns,
  getFormattedTitles,
  getHiddenColumns,
  getSearchableColumns,
  getSorter,
  createFilters,
  tableFilter,
} from "./GlobalFunctions";
import {
  COLUMN_WIDTHS,
  COLUMNS_WITH_ELLIPSIS,
  DEFAULT_HIDDEN_COLUMNS,
  FIXED_COLUMNS,
  SEARCHABLE_COLUMNS,
  TITLE_MAPPING,
} from "./MedicalHistoryConstants.js";
import { getCellRenderer } from "./MedicalHistoryFunctions";

export const getMedicalHistoryColumnConfig = (
  rows: Record<string, unknown>[],
  filteredInfo: Record<string, unknown[] | null>,
  ellipsis: boolean,
) => {
  const headers = rows.length > 0 ? Object.keys(rows[0]) : [];
  const columns = headers.map((header) => {
    const filters = createFilters(rows, header);
    return {
      title: () => getFormattedTitles(header, TITLE_MAPPING),
      dataIndex: header,
      key: header,
      sorter: getSorter(header),
      render: (text: string | null | undefined) =>
        getCellRenderer(text, header, ellipsis, COLUMNS_WITH_ELLIPSIS),
      width: getCellWidth(header, COLUMN_WIDTHS),
      filters: filters,
      filteredValue: (() => {
        return filteredInfo[header] || null;
      })(),
      onFilter: (value: boolean | React.Key, record: Record<string, unknown>) =>
        tableFilter(value, record, header),
      filterSearch: getSearchableColumns(header, SEARCHABLE_COLUMNS),
      hidden: getHiddenColumns(header, DEFAULT_HIDDEN_COLUMNS),
      fixed: getFixedColumns(header, FIXED_COLUMNS),
    };
  });

  return columns;
};
